import { gql } from 'graphql-tag';

export const createAlarmLimit = gql`
  mutation createAlarmLimit($input: AlarmLimitInput) {
    createAlarmLimit(input: $input) {
      id
      facilityId
      assetIdentifier
      alarmAttributeName
      value
      effectiveDateTime
      updatedAt
      updateReason
      datatype
    }
  }
`;
